module.exports = __webpack_public_path__ + "img/dt.51bccd8d.jpg";